<template>
  
		<!-- 详情 -->
		<div v-show="Bxjsgl_edit">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">保险基数管理-详情</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
                <div style="height:20px"></div>
				<!-- 表格 -->
				<div style="margin:2% 3% 0 3%">
					<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="540" @selection-change="handleSelectionChange"
                        :span-method="arraySpanMethod">
						<el-table-column prop="" align="center" label="城市"></el-table-column>
						<el-table-column prop="minimum_wage" align="center" label="最低工资"></el-table-column>
						<el-table-column prop="minimum_wage" align="center" label="五险"></el-table-column>
						<el-table-column prop="minimum_wage" align="center" label="缴费基数"></el-table-column>
						<el-table-column prop="minimum_wage" align="center" label="缴纳方式"></el-table-column>
						<el-table-column prop="minimum_wage" align="center" label="个人比例"></el-table-column>
						<el-table-column prop="minimum_wage" align="center" label="公司缴费比例">
							<el-table-column prop="minimum_wage" align="center" label="物业账户"></el-table-column>
							<el-table-column prop="minimum_wage" align="center" label="环境账户"></el-table-column>
						</el-table-column>
					</el-table>
				</div>

			</div>
		</div>
</template>

<script>
export default {
    data(){
        return{
            form:{
                city_id:'',
                minimum_wage:'',
                // 养老
                provideAged_base:'',
                provideAged_pay_type:'',
                provideAged_proportion:'',
                // 失业
                unemployment_base:'',
                unemployment_pay_type:'',
                unemployment_proportion:'',
                // 工伤
                industrial_injury_base:'',
                industrial_injury_type:'',
                industrial_injury_proportion:'',
                // 医疗
                medical_care_base:'',
                medical_care_pay_type:'',
                medical_care_proportion:'',
                // 生育
                birth_base:'',
                birth_pay_type:'',
                birth_proportion:'',
                // 大额医疗
                large_treatment_base:'',
                large_treatment_pay_type:'',
                large_treatment_proportion:'',
                large_treatment_month:'',
                // 公积金
                commonMpe_base:'',
                commonMpe_pay_type:'',
                commonMpe_proportion:'',
                // 公司缴费比例
                companyList: [{
                    pay_company:'',
                    pay_proportion:'',
                    flag: 0
                }],
            },
        }
    },
    methods:{
    },
    created() {
        
		},

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// Bxjsgl_edit.vue?4b0315bc